.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.card {
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: rgba(12, 10, 20, 0.65);
}

.recommended {
  border-color: var(--color-gold);
  box-shadow: 0 0 40px rgba(200, 161, 102, 0.12);
  transform: scale(1.02);
}

.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.badge {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-gold-bright);
  text-align: right;
  white-space: nowrap;
}

.cardTitle {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  min-width: 0;
}

.price {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--color-gold-bright);
  font-variant-numeric: tabular-nums;
}

.features {
  flex: 1;
  margin: 0 0 24px;
  padding: 0;
  list-style: none;
}

.features li {
  position: relative;
  padding-left: 18px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-muted);
}

.features li::before {
  content: "·";
  position: absolute;
  left: 0;
  color: var(--color-gold);
  font-weight: 700;
}

.footnote {
  font-size: 13px;
  text-align: center;
  color: var(--color-text-dim);
}

.exchangeRateNote {
  max-width: 820px;
  margin: 0 auto 12px;
  font-size: 12px;
  line-height: 1.55;
  text-align: center;
  color: var(--color-text-dim);
  opacity: 0.9;
}

.supportNote {
  max-width: 820px;
  margin: 12px auto 0;
  font-size: 12px;
  line-height: 1.55;
  text-align: center;
  color: var(--color-text-dim);
  opacity: 0.9;
}

@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .recommended {
    transform: none;
  }
}
